import script from "./AgentAddEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentAddEdit.vue?vue&type=script&setup=true&lang=js"

import "./AgentAddEdit.vue?vue&type=style&index=0&id=a40ab552&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a40ab552"]])

export default __exports__